import ConfirmationDialog from "@/shared/components/domain/confirmation/confirmation-dialog";
import { Button } from "@/shared/components/ui/button";
import { Trash } from "lucide-react";
import { useDeleteAddressMutation } from "@/services/backend/company/address-service";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";

interface DeleteAddressButtonProps {
  addressId: string;
}

export function DeleteAddressButton({ addressId }: DeleteAddressButtonProps) {
  const [deleteAddress, { error, isLoading }] = useDeleteAddressMutation();

  const onConfirm = () => {
    if (isLoading) {
      return;
    }

    deleteAddress({ id: addressId });
  };

  return (
    <>
      <RTKQueryErrorAlert error={error} />
      <ConfirmationDialog
        trigger={
          <Button className="bg-red-600">
            <Trash />
          </Button>
        }
        title="Adresse löschen"
        description="Hiermit wird die Adresse aus den Stammdaten des Unternehmens gelöscht."
        onConfirm={onConfirm}
      />
    </>
  );
}
